import { useEffect } from "react";
import { type ThemePreference } from "@jackedlogs/shared";
import { useThemePreferenceContext } from "@jackedlogs/ui";
import { useProfileDoc } from "./useProfileDoc";

// Bridges Profile.themePreference (cross-device source of truth) into the
// shared ThemeContext once the user is signed in. Renders nothing — it only
// fetches the profile doc (useProfileDoc's own effect) and forwards the
// themePreference field via syncRemote, which is a no-op once the user has
// picked something this session (see ThemeContext.tsx). Mounted inside
// App.tsx's signed_in branch so the profile fetch only happens post sign-in.
export function ThemeProfileBridge() {
  const { doc } = useProfileDoc();
  const ctx = useThemePreferenceContext();
  const themePreference = doc?.["themePreference"];

  useEffect(() => {
    ctx?.syncRemote(themePreference as Partial<ThemePreference> | null | undefined);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [themePreference]);

  return null;
}
